<template>
    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Exames solicitados no Atendimento do Ambulatório"
    >
        <rkm-alert
            class="mb-2"
            color="info"
        >
            Para agendar múltiplos exames, selecione exames do mesmo grupo e profissional solicitante.
        </rkm-alert>

        <rkm-row>
            <rkm-col>

                <Form
                    :exames="exames"
                    @handleSelecionado="handleSelecionado"
                    @agendarAmbulatorioAtendimento="agendarAmbulatorioAtendimento"
                    @descartarAmbulatorioAtendimento="descartar"
                />
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button
                v-if="selecionado"
                @click="descartarMultiple"
                color="primary"
                outline
            >
                Descartar exames
            </rkm-button>

            <rkm-button
                v-if="selecionado"
                :disabled="!examesSelecionadosMesmoGrupoUsuarioSolicitante"
                @click="multipleAmbulatorioAtendimento"
                color="primary"
            >
                Agendar exames
            </rkm-button>

            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

import Form from './Form'

export default {
    components: { Form },
    computed: {
        examesSelecionadosMesmoGrupoUsuarioSolicitante() {

            const exames = this.exames.filter(e => !!e.selecionado)

            let mesmoGrupoUsuarioSolicitante = true

            exames.forEach(exame => {

                if (exames.find(e => e.grupoId !== exame.grupoId || e.profissionalId !== exame.profissionalId)) {

                    mesmoGrupoUsuarioSolicitante = false
                }
            })

            return mesmoGrupoUsuarioSolicitante
        }
    },
    data: () => ({
        item: null,
        selecionado: false,
        exames: []
    }),
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento')
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            this.setLoading()

            this.repositories.agendamento.getExameAmbulatorioAtendimento({
                paciente_id: this.paciente.id,
            })
                .then(response => {

                    const exames = response.data

                    this.exames = exames.filter(
                        exame => Number(exame.isRascunho) === 0
                    ) 
                    
                    if (this.exames.length > 0) {

                        this.showConfirmation(
                            `O paciente possui registro de solicitação de exames de imagem no Atendimento
                            do Ambulatório. Deseja visualizar?`,
                            async () => this.$refs.RkmModal.show()
                        )
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        descartar(item) {

            this.showConfirmation(
                `Deseja realmente descartar o exame <strong>${item.exameNome}</strong>?`,
                async () => {

                    this.setLoading()

                    this.repositories.agendamento.descartarExameAmbulatorioAtendimento({
                        ambulatorio_atendimento_id: item.exameItemId,
                        multiple: false,
                    })
                        .then(response => {

                            if (response.data) {

                                const index = this.exames.findIndex((obj => obj.exameItemId == item.exameItemId));

                                this.exames.splice(index, 1)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            )
        },
        descartarMultiple() {

            this.showConfirmation(
                `Deseja realmente descartar os exames selecionados?`,
                async () => {
                    this.setLoading();

                    try {
                        const response = await this.repositories.agendamento.descartarExameAmbulatorioAtendimento({
                            exames: this.camelObjectKeysToSnakeRecursive(this.exames.filter(exame => exame.selecionado)),
                            multiple: true,
                        });

                        if (response.data) {

                            this.exames = this.exames.filter(exame => !exame.selecionado);
                        }
                    } catch (error) {
                        this.handleError(error);
                    } finally {
                        this.unsetLoading();
                    }
                }
            );
        },
        handleSelecionado(value) {

            this.selecionado = value
        },
        exit() {

            this.$refs.RkmModal.hide()
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        agendarAmbulatorioAtendimento(item) {

            this.$emit('agendarAmbulatorioAtendimento', item)
            this.$refs.RkmModal.hide()
        },
        multipleAmbulatorioAtendimento() {

            this.$emit('multipleAmbulatorioAtendimento', this.exames)
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        paciente: { type: Object, required: true},
    },
}
</script>

